import { useState, useEffect } from "react";
import Button from "../../Custom/Button/Button";
import { useGlobalContext } from "../../../Context/Context";
import CustomSelectSimple from "../Documents/evidencije/CustomSelectSimple";
import CustomSelectMultiple from "../Documents/globalno-dodavanje/CustomSelectMultiple";

const brojZaposlenihOptions = [
  "0-5",
  "5-10",
  "10-50",
  "50-100",
  "100-1000",
  ">1000",
];
const brojKlijenataOptions = [
  "0-10",
  "10-20",
  "20-50",
  "50-100",
  "100-500",
  "500+",
];

const styles = {
  button: { padding: "10px 20px" },
  divInput: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    minWidth: 0,
  },
  label: { fontSize: "16px", fontWeight: "bold", marginLeft: "7px" },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    padding: "5px",
  },
  input: { padding: "5px", fontSize: "16px", height: "unset", minWidth: 0 },
  btnContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "7px",
    alignItems: "center",
  },
  napomena: {
    fontSize: "13px",
    opacity: 0.7,
    fontStyle: "italic",
    padding: "8px",
    borderLeft: "3px solid #ccc",
  },
  svrhaBtn: {
    padding: "10px 15px",
    cursor: "pointer",
    border: "2px solid #ccc",
    borderRadius: "6px",
    fontSize: "15px",
    textAlign: "left",
  },
  svrhaSelected: {
    borderColor: "#333",
    fontWeight: "bold",
    background: "rgba(0,0,0,0.05)",
  },
  klijentRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "6px",
    background: "rgba(0,0,0,0.04)",
    borderRadius: "4px",
    fontSize: "14px",
  },
  klijentInput: { display: "flex", gap: "8px", alignItems: "flex-end" },
};

const numberRegex = /^\d*$/;

const emptyFirma = { company_name: "", company_address: "", pib: "" };

const emptyData = {
  company_name: "",
  company_address: "",
  pib: "",
  registration_number: "",
  official_email: "",
  number_of_employees: "",
  activity_code: "",
  user_email: "",
  bzr_license_number: "",
  license_valid_from: "",
  license_valid_to: "",
  advisor_name: "",
  advisor_email: "",
  advisor_license_number: "",
  client_count: "",
  regulations: [],
};

const emptyType1 = { name: "", user_email: "" };

const SVRHE = [
  { id: 1, label: "Lično upoznavanje sa namenom" },
  { id: 2, label: "Za sopstvene BZR poslove" },
  { id: 3, label: "Za pružanje BZR usluga klijentima" },
];

const NAPOMENA = `Adresa sa koje nam šaljete zahtev za registraciju mora biti istovetna sa adresom koju ste naveli u registracionoj formi, u protivnom proces registracije se automatski obustavlja.`;

const DodavanjeKlijentaOpening = ({
  openingType: initialOpeningType,
  onComplete,
}) => {
  const [selectedSvrha, setSelectedSvrha] = useState(
    initialOpeningType || null,
  );
  const [step, setStep] = useState(initialOpeningType ? "forma" : "svrha"); // "svrha" | "forma"
  const [data, setData] = useState(emptyData);
  const [type1Data, setType1Data] = useState(emptyType1);
  const [regulationsOptions, setRegulationsOptions] = useState([]);

  // Tip 3 - lista klijenata
  const [klijenti, setKlijenti] = useState([]);
  const [novaFirma, setNovaFirma] = useState(emptyFirma);

  const { dictionary, loggedUser, baseUrl } = useGlobalContext();

  useEffect(() => {
    fetch(`${baseUrl}/admin_panel/our_docs/read.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ type: "main_categories" }),
    })
      .then((r) => r.json())
      .then((res) => {
        if (res.status === 200) {
          setRegulationsOptions(
            res.categories.map((c) => ({ id: c.id, name: c.title })),
          );
        }
      })
      .catch(() => {});
  }, [baseUrl]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (
      ["registration_number", "pib"].includes(name) &&
      (!numberRegex.test(value) || value.length > 9)
    )
      return;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleType1Change = (e) => {
    const { name, value } = e.target;
    setType1Data((prev) => ({ ...prev, [name]: value }));
  };

  const handleNovaFirmaChange = (e) => {
    const { name, value } = e.target;
    if (name === "pib" && (!numberRegex.test(value) || value.length > 9))
      return;
    setNovaFirma((prev) => ({ ...prev, [name]: value }));
  };

  const handleDodajKlijenta = () => {
    if (
      !novaFirma.company_name ||
      !novaFirma.company_address ||
      novaFirma.pib.length !== 9
    )
      return;
    setKlijenti((prev) => [...prev, novaFirma]);
    setNovaFirma(emptyFirma);
  };

  const handleUkloniKlijenta = (index) => {
    setKlijenti((prev) => prev.filter((_, i) => i !== index));
  };

  // Tip 1 - otvori mail klijent
  const handleSendType1 = () => {
    const subject = encodeURIComponent(
      "Zahtev za registraciju - Lično upoznavanje",
    );
    const body = encodeURIComponent(
      `Ime i prezime: ${type1Data.name}\nE-adresa: ${type1Data.user_email}\nSvrha: Lično upoznavanje sa namenom`,
    );
    window.location.href = `mailto:registracija@nadzor.app?subject=${subject}&body=${body}`;
  };

  const handleSave = async () => {
    try {
      const payload =
        selectedSvrha === 3
          ? {
              ...data,
              regulations: data.regulations.map((r) => r.id),
              opening_type: selectedSvrha,
              user_id: loggedUser.id,
              klijenti,
            }
          : {
              ...data,
              regulations: data.regulations.map((r) => r.id),
              opening_type: selectedSvrha,
              user_id: loggedUser.id,
            };

      const response = await fetch(`${baseUrl}/opening/create.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const result = await response.json();
      if (result.status === 201) {
        if (selectedSvrha === 2) {
          window.open(
            `mailto:register@nadzor.app?subject=Zahtev za registraciju&body=Zahtev ID: ${result.request_id}`,
          );
          window.location.href = "http://localhost:5173";
        } else {
          window.location.href = "http://localhost:5173";
        }
      }
    } catch {
      alert("Serverska greška pri slanju.");
    }
  };

  // --- VALIDACIJA ---
  const isBaseDisabled =
    !data.company_name ||
    !data.company_address ||
    data.pib.length !== 9 ||
    !data.registration_number ||
    !data.official_email ||
    !data.user_email ||
    !data.number_of_employees ||
    !data.activity_code;

  const isSaveDisabled2 = isBaseDisabled;

  const isSaveDisabled3 =
    isBaseDisabled ||
    !data.bzr_license_number ||
    !data.license_valid_from ||
    !data.license_valid_to ||
    !data.advisor_name ||
    !data.advisor_email ||
    !data.advisor_license_number ||
    !data.client_count ||
    data.regulations.length === 0 ||
    klijenti.length !== parseInt(data.client_count); // <-- tačno toliko

  const isType1Disabled = !type1Data.name || !type1Data.user_email;

  // --- RENDER ---

  // Korak 1: izbor svrhe
  if (step === "svrha") {
    return (
      <div style={styles.container}>
        <div style={{ ...styles.label, fontSize: "18px" }}>
          SVRHA PREUZIMANJA
        </div>
        {SVRHE.map((s) => (
          <div
            key={s.id}
            style={{
              ...styles.svrhaBtn,
              ...(selectedSvrha === s.id ? styles.svrhaSelected : {}),
            }}
            onClick={() => setSelectedSvrha(s.id)}
          >
            {s.label}
          </div>
        ))}

        {/* Tip 1 - odmah ispod izbora */}
        {selectedSvrha === 1 && (
          <div style={{ ...styles.container, marginTop: "10px" }}>
            <div style={styles.divInput}>
              <div style={styles.label}>IME I PREZIME</div>
              <input
                name="name"
                value={type1Data.name}
                onChange={handleType1Change}
                style={styles.input}
              />
            </div>
            <div style={styles.divInput}>
              <div style={styles.label}>VAŠA E-ADRESA</div>
              <input
                name="user_email"
                value={type1Data.user_email}
                onChange={handleType1Change}
                style={styles.input}
                type="email"
              />
            </div>
            <div style={styles.napomena}>⚠️ {NAPOMENA}</div>
            <div style={styles.btnContainer}>
              <div
                style={{
                  opacity: isType1Disabled ? 0.5 : 1,
                  width: "90%",
                  height: "40px",
                }}
                onClick={isType1Disabled ? undefined : handleSendType1}
              >
                <Button isDisabled={isType1Disabled} activation={true}>
                  <span style={{ fontWeight: "bold" }}>POŠALJI</span>
                </Button>
              </div>
            </div>
          </div>
        )}

        {/* Dugme DALJE za tip 2 i 3 */}
        {(selectedSvrha === 2 || selectedSvrha === 3) && (
          <div style={styles.btnContainer}>
            <div
              style={{ width: "90%", height: "40px" }}
              onClick={() => setStep("forma")}
            >
              <Button activation={true}>
                <span style={{ fontWeight: "bold" }}>DALJE</span>
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }
  console.log({
    isBaseDisabled,
    bzr: !data.bzr_license_number,
    from: !data.license_valid_from,
    to: !data.license_valid_to,
    advisor_name: !data.advisor_name,
    advisor_email: !data.advisor_email,
    advisor_license: !data.advisor_license_number,
    client_count: !data.client_count,
    regulations: data.regulations.length === 0,
    klijenti: klijenti.length < 5,
  });
  // Korak 2: forma za tip 2 i 3
  return (
    <div style={styles.container}>
      {/* Zajednička polja */}
      <div style={styles.divInput}>
        <div style={styles.label}>POSLOVNO IME</div>
        <input
          name="company_name"
          value={data.company_name}
          onChange={handleChange}
          style={styles.input}
        />
      </div>
      <div style={styles.divInput}>
        <div style={styles.label}>ADRESA SEDIŠTA</div>
        <input
          name="company_address"
          value={data.company_address}
          onChange={handleChange}
          style={styles.input}
        />
      </div>
      <div style={{ display: "flex", gap: "10px" }}>
        <div style={{ ...styles.divInput, flex: 1 }}>
          <div style={styles.label}>PIB</div>
          <input
            name="pib"
            value={data.pib}
            onChange={handleChange}
            style={styles.input}
          />
        </div>
        <div style={{ ...styles.divInput, flex: 1 }}>
          <div style={styles.label}>MAT. BR.</div>
          <input
            name="registration_number"
            value={data.registration_number}
            onChange={handleChange}
            style={styles.input}
          />
        </div>
      </div>
      <div style={styles.divInput}>
        <div style={styles.label}>ZVAN. E-ADRESA</div>
        <input
          name="official_email"
          value={data.official_email}
          onChange={handleChange}
          style={styles.input}
          type="email"
        />
      </div>
      <div style={styles.divInput}>
        <div style={styles.label}>BR. ZAPOSLENIH / ŠIFRA DELATNOSTI</div>
        <div style={{ display: "flex", gap: "10px" }}>
          <div style={{ flex: 1 }}>
            <CustomSelectSimple
              allValues={brojZaposlenihOptions}
              selectedValue={data.number_of_employees}
              onSelectChange={(v) =>
                setData((prev) => ({ ...prev, number_of_employees: v }))
              }
            />
          </div>
          <input
            name="activity_code"
            value={data.activity_code}
            onChange={handleChange}
            style={{ ...styles.input, flex: 1 }}
            placeholder="Šifra"
          />
        </div>
      </div>
      <div style={styles.divInput}>
        <div style={styles.label}>VAŠA E-ADRESA</div>
        <input
          name="user_email"
          value={data.user_email}
          onChange={handleChange}
          style={styles.input}
          type="email"
        />
      </div>

      {/* Tip 3 - dodatna polja */}
      {selectedSvrha === 3 && (
        <>
          <hr style={{ opacity: 0.2, margin: "4px 0" }} />
          <div style={{ display: "flex", gap: "10px" }}>
            <div style={{ ...styles.divInput, flex: 1 }}>
              <div style={styles.label}>BR. BZR LICENCE</div>
              <input
                name="bzr_license_number"
                value={data.bzr_license_number}
                onChange={handleChange}
                style={styles.input}
              />
            </div>

            <div style={{ ...styles.divInput, flex: 1 }}>
              <div style={styles.label}>BROJ KLIJENATA</div>
              <input
                name="client_count"
                value={data.client_count}
                onChange={handleChange}
                style={styles.input}
                type="number"
                min="1"
              />
            </div>
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <div style={{ ...styles.divInput, flex: 1 }}>
              <div style={styles.label}>VAŽI OD</div>
              <input
                name="license_valid_from"
                value={data.license_valid_from}
                onChange={handleChange}
                style={styles.input}
                type="date"
              />
            </div>
            <div style={{ ...styles.divInput, flex: 1 }}>
              <div style={styles.label}>VAŽI DO</div>
              <input
                name="license_valid_to"
                value={data.license_valid_to}
                onChange={handleChange}
                style={styles.input}
                type="date"
              />
            </div>
          </div>
          <div style={styles.divInput}>
            <div style={styles.label}>IME I PREZIME SAVETNIKA</div>
            <input
              name="advisor_name"
              value={data.advisor_name}
              onChange={handleChange}
              style={styles.input}
            />
          </div>
          <div style={styles.divInput}>
            <div style={styles.label}>E-ADRESA SAVETNIKA</div>
            <input
              name="advisor_email"
              value={data.advisor_email}
              onChange={handleChange}
              style={styles.input}
              type="email"
            />
          </div>
          <div style={styles.divInput}>
            <div style={styles.label}>BR. LICENCE SAVETNIKA</div>
            <input
              name="advisor_license_number"
              value={data.advisor_license_number}
              onChange={handleChange}
              style={styles.input}
            />
          </div>
          <div style={styles.divInput}>
            <CustomSelectMultiple
              label="KOJE PROPISE"
              allValues={regulationsOptions}
              selectedValues={data.regulations}
              displayNumber={true}
              onSelectChange={(value) => {
                const already = data.regulations.find((v) => v.id === value.id);
                if (already) {
                  setData((prev) => ({
                    ...prev,
                    regulations: prev.regulations.filter(
                      (v) => v.id !== value.id,
                    ),
                  }));
                } else {
                  setData((prev) => ({
                    ...prev,
                    regulations: [...prev.regulations, value],
                  }));
                }
              }}
            />
          </div>

          {/* Lista klijenata */}
          <hr style={{ opacity: 0.2, margin: "4px 0" }} />
          <div style={{ ...styles.label, fontSize: "15px" }}>
            KLIJENTI (minimum 5)
          </div>
          <div style={styles.klijentInput}>
            <div style={{ ...styles.divInput, flex: 2 }}>
              <div style={styles.label}>NAZIV</div>
              <input
                name="company_name"
                value={novaFirma.company_name}
                onChange={handleNovaFirmaChange}
                style={styles.input}
              />
            </div>
            <div style={{ ...styles.divInput, flex: 2 }}>
              <div style={styles.label}>ADRESA</div>
              <input
                name="company_address"
                value={novaFirma.company_address}
                onChange={handleNovaFirmaChange}
                style={styles.input}
              />
            </div>
            <div style={{ ...styles.divInput, flex: 1 }}>
              <div style={styles.label}>PIB</div>
              <input
                name="pib"
                value={novaFirma.pib}
                onChange={handleNovaFirmaChange}
                style={styles.input}
              />
            </div>
            <div
              style={{ height: "40px", minWidth: "60px" }}
              onClick={handleDodajKlijenta}
            >
              <Button activation={true}>
                <span style={{ fontWeight: "bold" }}>+</span>
              </Button>
            </div>
          </div>

          {klijenti.map((k, i) => (
            <div key={i} style={styles.klijentRow}>
              <span style={{ flex: 1 }}>✓ {k.company_name}</span>
              <span style={{ flex: 1, opacity: 0.7 }}>{k.company_address}</span>
              <span style={{ opacity: 0.7 }}>{k.pib}</span>
              <span
                style={{ cursor: "pointer", color: "red", marginLeft: "8px" }}
                onClick={() => handleUkloniKlijenta(i)}
              >
                ✕
              </span>
            </div>
          ))}
          <div style={{ fontSize: "13px", opacity: 0.6 }}>
            Dodato: {klijenti.length}/{data.client_count || 0}
          </div>
        </>
      )}

      <div style={styles.napomena}>⚠️ {NAPOMENA}</div>

      <div style={styles.btnContainer}>
        <div
          style={{
            opacity: (selectedSvrha === 2 ? isSaveDisabled2 : isSaveDisabled3)
              ? 0.5
              : 1,
            width: "90%",
            height: "40px",
          }}
          onClick={handleSave}
        >
          <Button
            isDisabled={selectedSvrha === 2 ? isSaveDisabled2 : isSaveDisabled3}
            activation={true}
          >
            <span style={{ fontWeight: "bold" }}>
              {dictionary["sacuvaj"] || "Sačuvaj"}
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DodavanjeKlijentaOpening;
